export default {
	'nav.home': '首页',
	'nav.personal': '个人中心',
	'common.add': '新增',
	'common.create': '创建',
	'common.save': '保存',
	'common.update': '更新',
	'common.view': '查看',
	'common.edit': '编辑',
	'common.delete': '删除',
	'common.batchDelete': '批量删除',
	'common.search': '查询',
	'common.detail': '详情',
	'common.refresh': '刷新',
	'common.reset': '重置',
	'common.export': '导出',
	'common.login': '登录',
	'common.logout': '退出登录',
	'common.cancel': '取消',
	'common.confirm': '确定',
	'common.ok': '确定',
	'common.close': '关闭',
	'common.enable': '启用',
	'common.disable': '停用',
	'common.import': '导入',
	'common.reImport': '重新导入',
	'common.clear': '清空',
	'common.themeColor': '主题色'
};
